import React from 'react';
import { theme } from 'antd';

const { useToken } = theme;

const ArrowRightIcon = ({ color, ...rest }: { color?: string; className?: string; [x: string]: unknown }) => {
  const { token } = useToken();
  return (
    <svg width="12px" height="12px" viewBox="0 0 12 12" version="1.1" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="Sensors-Selection-+-Pressure-Sensors-Config."
          transform="translate(-1156.000000, -412.000000)"
          fill={color ?? token.colorTextTertiary}
          fillRule="nonzero"
        >
          <g id="Group-11" transform="translate(238.000000, 196.000000)">
            <g id="Group-15" transform="translate(365.000000, 46.000000)">
              <g id="up-and-down-copy" transform="translate(553.000000, 170.000000)">
                <path d="M10.1836 5.71641L5.75625 1.87383C5.72227 1.84453 5.67891 1.82812 5.6332 1.82812H4.59609C4.50938 1.82812 4.46953 1.93594 4.53516 1.99219L8.63906 5.55469H1.78125C1.72969 5.55469 1.6875 5.59687 1.6875 5.64844V6.35156C1.6875 6.40312 1.72969 6.44531 1.78125 6.44531H8.63789L4.53398 10.0078C4.46836 10.0652 4.5082 10.1719 4.59492 10.1719H5.66719C5.68945 10.1719 5.71172 10.1637 5.72812 10.1484L10.1836 6.28359C10.2242 6.24832 10.2567 6.20474 10.279 6.15582C10.3013 6.1069 10.3128 6.05376 10.3128 6C10.3128 5.94624 10.3013 5.8931 10.279 5.84418C10.2567 5.79526 10.2242 5.75168 10.1836 5.71641Z" />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default ArrowRightIcon;
